<template lang="pug">
.link-wrapper
  a.link.type-standard(v-if="queryMatchesLink" :href="link.path") {{ link.name }}
  .inset(v-if="link.subLinks")
    SitemapLink(
      v-for="sublink in link.subLinks"
      :key="sublink.name"
      :link="sublink"
      :query="query"
      )
</template>

<script>
export default {
  name: 'SitemapLink',
  props: {
    link: Object,
    query: String,
  },
  computed: {
    queryMatchesLink() {
      if (!this.query) return true
      return this.link.name.toLowerCase().includes(this.query.toLowerCase())
    },
  },
}
</script>

<style scoped lang="stylus">
.link-wrapper
  display block
  width 100%
  overflow hidden
  margin-top 5px

.link
  color blue
  text-decoration underline

.inset
  margin-left 20px
</style>
